import React from 'react';
import { QuoteStatus } from '@/lib/types';

interface StatusBadgeProps {
  status: QuoteStatus;
  size?: 'sm' | 'md';
}

export default function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const sizeClass = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-xs';

  return (
    <span className={`inline-flex items-center gap-1 font-semibold rounded-full ${sizeClass} status-badge-${status.toLowerCase()}`}>
      <span
        className={`w-1.5 h-1.5 rounded-full inline-block ${
          status === 'Draft' ? 'bg-gray-400' :
          status === 'Sent' ? 'bg-blue-500' :
          status === 'Approved'? 'bg-green-600' : 'bg-red-500'
        }`}
      />
      {status}
    </span>
  );
}